//@ts-nocheck
import { routingMixin } from "@jack-henry/web-component-router";
import { LitElement, css, html, PropertyValues, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { deleteRequest, fixedEncodeURIComponent, getRequest, postRequest, putRequest } from "../../utils/jha-fetch";
import { Apis } from "../../utils/api-constants";
import { getErrorMessage } from "../../utils/getErrorMessage";
import { GlobalVariables } from "../../utils/constants";
import { showToast } from "@banno/jha-wc/src/js/utils/toast-util.js";
import { AppRouters } from "../../utils/app-router";
import { StatusConstants } from "../../utils/apiStatusConstants";
import {
	ADVANCED_TABLE_SORT_BUTTON_HEADER_STYLES_TEXT,
	applyAdvancedTableHeaderLayout,
	decryptValue,
	stringComparison,
	formatToUTC,
	getEnvApiUrl,
	buildAdvancedTableJhaTooltipOverflowEscapeCss,
	buildAdvancedTableEllipsisColumnShadowCss,
	renderAdvancedTableEllipsisCell,
	stripAdvancedTableRedundantTitles,
} from "../../utils/app-utils";
import {
	dateTimeColumnLabel,
	EFM_TIMEZONE_GRID_TABLE_SHADOW_STYLES_TEXT,
	EFM_TIMEZONE_GRID_TABLE_STYLE,
	formatDateTimeForDisplay,
	normalizeEpochSeconds,
	orderLoadedRowsByEpoch,
	renderGridWithTimezoneBanner,
} from "../../utils/datetime-display";
import { filterSelectBackspaceClearKeydown } from "../../utils/filter-field-keyboard";
import { openJhftDialog } from "../../Components/JhftJhaDialog";
import Cookies from "js-cookie";
import "@banno/jha-wc/src/forms/jha-form-input-base/jha-form-input";
import "@banno/jha-wc/src/forms/jha-form-row/jha-form-row";
import "@banno/jha-wc/src/tables/jha-table-row/jha-table-row";
import "@banno/jha-wc/src/tables/jha-table-header/jha-table-header";
import "@banno/jha-wc/src/tables/jha-table-cell/jha-table-cell";
import "@banno/jha-wc/src/buttons/jha-button/jha-button";
import "@banno/jha-wc/src/icons/jha-icon-reports";
import "@banno/jha-wc/src/icons/jha-icon-circle-checkmark-filled";
import "@banno/jha-wc/src/icons/jha-icon-circle-close-filled";
import "@banno/jha-wc/src/cards/jha-card/jha-card";
import "@banno/jha-wc/src/dropdowns/jha-dropdown-toggle/jha-dropdown-toggle";
import "@banno/jha-wc/src/dropdowns/jha-dropdown-menu/jha-dropdown-menu";
import "@banno/jha-wc/src/dropdowns/jha-dropdown-menu-item/jha-dropdown-menu-item";
import "@banno/jha-wc/src/dropdowns/jha-dropdown/jha-dropdown";
import "@jack-henry/jh-ui/components/input/input.js";
import "./CreateWorkflowTabView";
import "../../Components/Loader";
import "@banno/jha-wc/src/tables/advanced/jha-advanced-table/jha-advanced-table";
import { jhaDropdownMenuPanelStyles, jhaDropdownMenuPanelStylesText } from "../../styles/jha-dropdown-menu-panel";
import { FeatureFlags } from "../../utils/launchdarkly-config";
import { launchDarkly } from "../../utils/launchdarkly-service";
import { isWorkflowActivationFeatureEnabled } from "../../utils/workflow-activation-feature-gate";
import {
	activateWorkflow,
	buildWorkflowActivationUserMessage,
	UI_ACTIVATION_MAX_WAIT_SECONDS,
} from "../../utils/workflow-activate";
import { extractSourceLocationSuffix } from "../../utils/workflow-source-location-path";

/** Grid columns that keep `title` on inner ellipsis markup (not the WC cell button). */
const WORKFLOW_GRID_ELLIPSIS_TITLE_COLUMN_IDS = new Set([
	"workflowName",
	"sourcePath",
]);

const WORKFLOW_PRESERVE_INNER_TITLE_COLUMN_IDS = new Set([
	"actionId",
	"status",
]);

interface WorkflowItem {
	workflowName: string;
	triggerFilePattern: string;
	sourceLocationPath_name: string;
	sourceLocationPath: string;
}

@customElement("workflow-main-view")
export class WorkflowMainView extends routingMixin(LitElement) {
	/** Larger batches during pager catch-up reduce round-trips; the grid still shows `pageLimit` rows per page. */
	private static readonly WORKFLOW_SEEK_MAX_COUNT = 400;
	/**
	 * Minimum rows requested on each full refresh (initial load, sort change, Apply filters, reset).
	 * Fetching more than one "page" per request cuts sequential round-trips when the API is slow;
	 * the table still displays `pageLimit` rows per page from the accumulated buffer.
	 */
	private static readonly WORKFLOW_FIRST_PAGE_MIN_COUNT = 100;

	static get is() {
		return "workflow-main-view";
	}

	static readonly styles = [jhaDropdownMenuPanelStyles, css`
		#workflowMain {
			display: flex;
			flex-direction: column;
			padding: 24px;
			flex: 1;
			box-sizing: border-box;
			overflow: hidden;
		}

		#formCon {
			display: flex;
			flex-direction: row;
			gap: 15px;
			align-items: center;
			justify-content: space-between;
		}

		#table-container {
			display: flex;
			height: 100%;
		}

		#noData {
			display: flex;
			justify-content: center;
		}

		.table-header-container {
			width: 100%;
			display: block !important;
			visibility: visible !important;
			opacity: 1 !important;
		}

		.inputContainer {
			display: flex;
			align-items: center;
			gap: 16px;
		}

		jh-input {
			max-width: 350px;
		}

		jha-form-row {
			align-items: baseline;
			justify-content: flex-end;
			flex: 1;
		}

		jha-table-header {
			width: 20vw;
		}

		jha-card {
			margin-top: 10px;
			flex: 1;
			overflow: hidden;
			margin-left: 0px;
			margin-right: 0px;
			padding: 5px;
		}
		.marginTop15px {
			margin-top: 15px;
		}

		.last-run-cell {
			display: inline-flex;
			align-items: center;
			gap: 8px;
			white-space: nowrap;
			line-height: 1;
		}

		.last-run-cell jha-icon-circle-checkmark-filled,
		.last-run-cell jha-icon-circle-close-filled {
			display: inline-flex;
			align-items: center;
			flex-shrink: 0;
		}

		.last-run-cell jha-icon-circle-checkmark-filled {
			fill: var(--jha-color-success, #2e7d32);
			color: var(--jha-color-success, #2e7d32);
		}

		.last-run-cell jha-icon-circle-close-filled {
			fill: var(--jha-color-warning, #d32f2f);
			color: var(--jha-color-warning, #d32f2f);
		}
	`];

	@property({ type: Boolean }) isReadOnlyUser = /readonly/i.test(decryptValue(Cookies.get("userRole") || ""));
	@property({ type: Boolean }) isEnterpriseAdmin = /enterpriseadmin/i.test(decryptValue(Cookies.get("userType") || ""));
	@property({ type: Array }) workflowData: Array<any> = [];
	@property({ type: Array }) workflowDataClone: Array<any> = [];
	@property({ type: Boolean }) dataupdated = false;
	@property() pageTitle = "Workflow";
	@property() filterStatus = "";
	@property() workflowName = "";
	@property() filterTransferType = "";
	@property()
	loggedUserType = decryptValue(Cookies.get("userType"));
	@property()
	filterBusinessUnit = stringComparison(this.loggedUserType, "BusinessAdmin") ? Cookies.get("businessUnit")?.toLowerCase() : "";
	@property()
	bussinessUnit = "";
	@property()
	isFilterSearch = false;
	@property({ type: Array })
	columns: Array<{
		label: string;
		id: string;
		sortBy?: boolean;
		dataType?: string;
		valueRenderer?: (val: any, row?: any) => any;
		valueFormatter?: (val: any, row?: any) => any;
	}> = [];
	@property({ type: Array }) businessUnits: Array<{ value: string; name: string }> = [];
	@property({ type: Array }) transferType: Array<{ value: string; name: string }> = [];
	@state() showWorkflowActivation = false;
	@state() activatingWorkflowId: string | null = null;
	@state() statusUpdateInFlightId: string | null = null;
	@property({ type: Array }) statusType: Array<{ value: string; name: string }> = [];

	private resolveWorkflowETag(workData: { eTag?: string; ETag?: string } | null | undefined): string {
		return (workData?.eTag ?? workData?.ETag ?? "").trim();
	}

	private workflowRowStatus(row: { status?: string; sourceLocationPath_status?: string }): string {
		if (row?.status) {
			return row.status;
		}
		const encoded = row?.sourceLocationPath_status ?? "";
		const separatorIndex = encoded.indexOf("~");
		return separatorIndex >= 0 ? encoded.substring(separatorIndex + 1) : "";
	}

	private isWorkflowActive(row: { status?: string; sourceLocationPath_status?: string }): boolean {
		return stringComparison(this.workflowRowStatus(row), "ACTIVE");
	}

	private canRunWorkflowNow(row: {
		status?: string;
		workflowId?: string;
		sourceLocationPath_status?: string;
	}): boolean {
		if (this.isReadOnlyUser || !this.isWorkflowActive(row)) {
			return false;
		}
		return this.activatingWorkflowId !== row?.workflowId;
	}

	private renderRunWorkflowNowMenuItem(row: {
		status?: string;
		workflowId?: string;
		sourceLocationPath_status?: string;
		workflowName?: string;
		transferType?: string;
	}) {
		return html`<jha-dropdown-menu-item
			role="link"
			data-auto-id="runWorkflowNowMenuItem"
			@click=${() => this.onRunWorkflowNowClick(row)}>
			<a>Run Workflow Now</a>
		</jha-dropdown-menu-item>`;
	}

	private normalizeWorkflowDateRaw(val: string): string {
		const raw = String(val).trim();
		return /^\d{4}-\d{2}-\d{2}T/.test(raw) || /^\d{10,13}$/.test(raw)
			? raw
			: formatToUTC(raw as any);
	}

	/** Display for grid date cells; accepts API strings or epoch-second sort keys (ACME-821). */
	private formatWorkflowGridDate(val: string | number | null | undefined): string {
		if (val == null) {
			return "--";
		}
		if (typeof val === "number") {
			if (!Number.isFinite(val) || val <= 0) {
				return "--";
			}
			const formatted = formatDateTimeForDisplay(val);
			return formatted || "--";
		}
		if (String(val).trim() === "") {
			return "--";
		}
		const formatted = formatDateTimeForDisplay(this.normalizeWorkflowDateRaw(String(val)));
		return formatted || "--";
	}

	private formatMetadataValue(val: string | null | undefined): string {
		const trimmed = (val ?? "").toString().trim();
		return trimmed || "--";
	}

	private buildCreatedDateTooltipText(row: {
		updateDateTime?: string;
		updatedBy?: string;
		createdBy?: string;
	}): string {
		const updateRaw = row?.updateDateTime;
		const modifiedDate =
			updateRaw != null && String(updateRaw).trim() !== ""
				? formatDateTimeForDisplay(this.normalizeWorkflowDateRaw(String(updateRaw)))
				: "--";
		return [
			`Last Modified Date: ${modifiedDate}`,
			`Last Modified By: ${this.formatMetadataValue(row?.updatedBy)}`,
			`Created By: ${this.formatMetadataValue(row?.createdBy)}`,
		].join("\n");
	}

	private formatLastRunDisplay(row: {
		lastRunDateTime?: string | null;
		lastRunStatus?: string | null;
	}): string {
		const time = (row?.lastRunDateTime ?? "").toString().trim();
		if (!time || time === "Never") {
			return "Never";
		}
		return this.formatWorkflowGridDate(time);
	}

	private formatNextScheduledRunDisplay(row: {
		transferType?: string;
		status?: string;
		sourceLocationPath_status?: string;
		scheduler?: { expression?: string } | null;
		nextScheduledRunTime?: string | null;
	}): string {
		if (stringComparison(row?.transferType, "PUSH")) {
			return "N/A";
		}
		if (!this.isWorkflowActive(row)) {
			return "Disabled";
		}
		const expression = (row?.scheduler?.expression ?? "").toString().trim();
		const next = (row?.nextScheduledRunTime ?? "").toString().trim();
		// Skip if listData already wrote a sentinel / display string onto the field
		if (next === "N/A" || next === "Disabled" || next === "Not Scheduled") {
			return next;
		}
		if (!expression || !next) {
			return "Not Scheduled";
		}
		// Already human-formatted (contains comma / slash from prior listData pass)
		if (/[/,]/.test(next) && !/^\d{4}-\d{2}-\d{2}T/.test(next)) {
			return next;
		}
		return this.formatWorkflowGridDate(next);
	}

	private renderLastRunCell(row: {
		lastRunDateTime?: string | null;
		lastRunStatus?: string | null;
	}) {
		const display = this.formatLastRunDisplay(row);
		if (display === "Never") {
			return html`<span data-auto-id="lastRunCell">Never</span>`;
		}
		const status = (row?.lastRunStatus ?? "").toString().trim().toLowerCase();
		const icon =
			status === "success"
				? html`<jha-icon-circle-checkmark-filled
						data-auto-id="lastRunSuccessIcon"
						style="fill: var(--jha-color-success, #2e7d32); color: var(--jha-color-success, #2e7d32);"
					></jha-icon-circle-checkmark-filled>`
				: status === "error"
					? html`<jha-icon-circle-close-filled
							data-auto-id="lastRunErrorIcon"
							style="fill: var(--jha-color-warning, #d32f2f); color: var(--jha-color-warning, #d32f2f);"
						></jha-icon-circle-close-filled>`
					: nothing;
		return html`<span class="last-run-cell" data-auto-id="lastRunCell">${icon}<span>${display}</span></span>`;
	}

	createColumns() {
		const baseColumns: typeof this.columns = [
			{
				label: "NAME",
				id: "workflowName",
				sortBy: true,
				valueRenderer: (val) => renderAdvancedTableEllipsisCell(val),
			},
			{
				label: "REPORTING",
				id: "viewReport",
				sortBy: false,
				valueFormatter: () => "Reporting",
				valueRenderer: (_val, row) => html`
					<jha-tooltip bottom text="View report for this workflow">
						<jha-button
							data-auto-id="viewReportBtn"
							type="button"
							icon
							sync
							aria-label="View report for ${row?.workflowName ?? "this workflow"}"
							@click=${(e: Event) => {
						e.stopPropagation();
						this.onViewReportClick(row?.workflowId, row?.workflowName);
					}}
						><jha-icon-reports
							style="fill: var(--jha-color-primary, #1976d2); color: var(--jha-color-primary, #1976d2);"
						></jha-icon-reports></jha-button>
					</jha-tooltip>
				`,
			},
			{
				label: dateTimeColumnLabel("CREATED DATE"),
				id: "createDateTime",
				sortBy: true,
				dataType: "number",
				valueFormatter: () => "",
				valueRenderer: (val, row) => html`
					<jha-tooltip bottom text=${this.buildCreatedDateTooltipText(row)}>
						<span data-auto-id="createdDateCell">${this.formatWorkflowGridDate(val)}</span>
					</jha-tooltip>
				`,
			},
			{
				label: dateTimeColumnLabel("LAST RUN"),
				id: "lastRunDateTime",
				sortBy: false,
				valueFormatter: (_val, row) => this.formatLastRunDisplay(row),
				valueRenderer: (_val, row) => this.renderLastRunCell(row),
			},
			{
				label: dateTimeColumnLabel("NEXT SCHEDULED RUN"),
				id: "nextScheduledRunTime",
				sortBy: false,
				valueFormatter: (_val, row) => this.formatNextScheduledRunDisplay(row),
				valueRenderer: (_val, row) =>
					html`<span data-auto-id="nextScheduledRunCell">${this.formatNextScheduledRunDisplay(row)}</span>`,
			},
			{
				label: "TRANSFER TYPE",
				id: "transferType",
				sortBy: true,
			},
			{
				label: "SOURCE PATH",
				id: "sourcePath",
				sortBy: true,
				valueRenderer: (val) => renderAdvancedTableEllipsisCell(val),
			},
		];

		// Add BUSINESS UNIT column only for enterprise admin
		if (this.isEnterpriseAdmin) {
			baseColumns.push({
				label: "BUSINESS UNIT",
				id: "businessUnitParticipant",
				sortBy: true,
				valueFormatter: (val) => (val ? val : ""),
			});
		}

		baseColumns.push(
			{
				label: "STATUS",
				id: "status",
				sortBy: true,
				valueFormatter: (val) => `${val ?? ""}`,
				valueRenderer: (val, row) => html`
					<jha-form-switch
						?disabled=${this.isReadOnlyUser ||
					this.statusUpdateInFlightId === row?.workflowId}
						title=${val}
						?checked=${stringComparison(val, "active")}
						@change=${() => this.updateWorkflowStatus(row?.workflowId)}
					>
					</jha-form-switch>
				`,
			},
			{
				label: "",
				id: "actionId",
				valueFormatter: () => `Menu`,
				valueRenderer: (item, row) => html`
					<jha-dropdown adjustToPageBottom title="Click for Options">
						<jha-dropdown-toggle slot="toggle" tabindex="0" aria-expanded="false" aria-haspopup="true" role="button">
							<jha-icon-view-more></jha-icon-view-more>
						</jha-dropdown-toggle>
						<jha-dropdown-menu>
							<jha-dropdown-menu-item role="link" @click=${() => this.onEditClick(item)}>
								<a> ${this.isReadOnlyUser || stringComparison(row.status.toUpperCase(), "ACTIVE") ? "View Workflow" : "Edit Workflow"} </a>
							</jha-dropdown-menu-item>
							${this.showWorkflowActivation &&
						stringComparison(row.transferType, "PULL") &&
						this.canRunWorkflowNow(row)
						? this.renderRunWorkflowNowMenuItem(row)
						: nothing}
							${this.isReadOnlyUser
						? ""
						: html`
										<jha-dropdown-menu-item role="link" @click=${() => this.onCloneClick(item)}>
											<a>Clone Workflow</a>
										</jha-dropdown-menu-item>
										<jha-dropdown-menu-item role="link" @click=${() => this.onDeleteClick(item)}>
											<a>Delete Workflow</a>
										</jha-dropdown-menu-item>
									`}
						</jha-dropdown-menu>
					</jha-dropdown>
				`,
			},
		);

		this.columns = baseColumns.slice();
	}

	@property() sortColumnId = "";
	@property() sortDirection = "";
	@property({ type: Boolean }) apiLoading = false;
	@property({ type: Object }) advancedTableConfig = {
		apiControlled: true,
		apiTotal: 100,
		sort: {
			columnId: "updateDateTime",
			descending: true,
		},
	};
	@property() nextPageKey = "";
	@property({ type: Boolean }) loadingMore = false;
	@property({ type: Number }) pageLimit = 50;
	@property({ type: Boolean }) searchWorkflow = false;
	@property()
	filterWorkflowName = "";

	/** Serializes cursor-based page fetches so rapid "next" clicks and jump-to-page cannot interleave requests. */
	private _workflowPagedFetchChain: Promise<void> = Promise.resolve();
	/** jha-advanced-table does not emit events for all pager moves; poll so we load rows for the current page offset. */
	private _workflowPageSyncTimer: ReturnType<typeof setInterval> | undefined;

	private refreshWorkflowActivationFlag = (): void => {
		this.showWorkflowActivation = isWorkflowActivationFeatureEnabled();
	};

	private handleWorkflowActivationFlagChange = (newValue: boolean): void => {
		this.showWorkflowActivation = newValue;
		this.requestUpdate("showWorkflowActivation", !newValue);
	};

	async connectedCallback() {
		super.connectedCallback();
		this.refreshWorkflowActivationFlag();
		launchDarkly.whenReady().then(() => this.refreshWorkflowActivationFlag());
		launchDarkly.on(FeatureFlags.OPCON_WORKFLOW_ACTIVATION, this.handleWorkflowActivationFlagChange);
		document.title = GlobalVariables.MAIN_TITLE?.concat(" >", this.pageTitle);
		// Align POST body with the Business Unit dropdown on first paint (same as after Apply Filters)
		// so the first request is not an unscoped search when the UI already shows a BU.
		this.bussinessUnit = this.filterBusinessUnit;
		this.createColumns();
		this._workflowPageSyncTimer = setInterval(() => this.scheduleWorkflowPageCatchUp(), 300);
	}

	/**
	 * When the main Workflows grid is shown (not create/edit/clone subroutes), reload the list.
	 * Navigating back from a child route uses the same path without a child — this runs then.
	 */
	async routeEnter(currentNode: unknown, nextNodeIfExists: unknown, routeId: string, context: unknown) {
		await super.routeEnter(currentNode, nextNodeIfExists, routeId, context);
		if (!nextNodeIfExists) {
			const listOk = await this.getAllWorkflowList();
			if (listOk) {
				await this.bindDDLData();
			}
		}
	}

	disconnectedCallback() {
		if (this._workflowPageSyncTimer !== undefined) {
			clearInterval(this._workflowPageSyncTimer);
			this._workflowPageSyncTimer = undefined;
		}
		launchDarkly.off(FeatureFlags.OPCON_WORKFLOW_ACTIVATION, this.handleWorkflowActivationFlagChange);
		super.disconnectedCallback();
	}

	/** Row count required in memory so visibleSlice covers the table's current page (matches jha-advanced-table startEnd). */
	private rowsNeededForTablePage(pageOffset: number): number {
		const total = this.advancedTableConfig?.apiTotal ?? 0;
		if (!total) {
			return 0;
		}
		const limit = this.pageLimit;
		const endExclusive = pageOffset * limit + limit;
		return Math.min(total, endExclusive);
	}

	private enqueueWorkflowPagedOp(op: () => Promise<void>): Promise<void> {
		const next = this._workflowPagedFetchChain.then(op).catch(() => { });
		this._workflowPagedFetchChain = next;
		return next;
	}

	/** Loads additional workflow-search pages until workflowData covers the pager's current page (stays in sync with fast "next"). */
	private scheduleWorkflowPageCatchUp() {
		if (this.searchWorkflow) {
			return;
		}
		const table = this.shadowRoot?.querySelector("jha-advanced-table");
		if (!table) {
			return;
		}
		const pageOffset = table.pageOffset ?? 0;
		const needed = this.rowsNeededForTablePage(pageOffset);
		if (needed <= 0 || this.workflowData.length >= needed || !this.nextPageKey) {
			return;
		}
		void this.enqueueWorkflowPagedOp(async () => {
			this.loadingMore = true;
			this.apiLoading = true;
			try {
				while (!this.searchWorkflow) {
					const t = this.shadowRoot?.querySelector("jha-advanced-table");
					const off = t?.pageOffset ?? 0;
					const need = this.rowsNeededForTablePage(off);
					if (need <= 0 || this.workflowData.length >= need || !this.nextPageKey) {
						break;
					}
					const remaining = need - this.workflowData.length;
					const batchCount = Math.min(
						Math.max(remaining, this.pageLimit),
						WorkflowMainView.WORKFLOW_SEEK_MAX_COUNT,
					);
					const ok = await this.fetchNextWorkflowPage({ count: batchCount });
					if (!ok) {
						break;
					}
				}
			} finally {
				this.loadingMore = false;
				this.apiLoading = false;
			}
		});
	}
	async bindDDLData() {
		// getEnvApiUrl: localhost-only; .env.local never ships — no effect in prod, test, staging, or CI builds.
		const businessUnitsAllRes = await getRequest(getEnvApiUrl(Apis.GET_ALL_BUSINESSUNITVALUES));
		if (!businessUnitsAllRes) {
			this.businessUnits = [];
			this.transferType = [
				{ value: "pull", name: "PULL" },
				{ value: "push", name: "PUSH" },
			];
			this.statusType = [
				{ value: "active", name: "ACTIVE" },
				{ value: "inactive", name: "INACTIVE" },
			];
			return;
		}
		const businessUnitsRes = businessUnitsAllRes?.businessUnitValues ?? [];
		this.businessUnits = businessUnitsRes
			.map((y) => {
				return { value: y.value, name: y.name };
			})
			.sort((a, b) => a.name.localeCompare(b.name));
		this.transferType = [
			{ value: "pull", name: "PULL" },
			{ value: "push", name: "PUSH" },
		];
		this.statusType = [
			{ value: "active", name: "ACTIVE" },
			{ value: "inactive", name: "INACTIVE" },
		];
	}

	get listData() {
		const rows = this.workflowData.map((item) => {
			const sourceLocationPath_name =
				item.sourceLocationPath != undefined
					? item.sourceLocationPath.substring(1, item.sourceLocationPath.indexOf("/", item.sourceLocationPath.indexOf("/") + 1))
					: "";

			const sourcePath =
				item.sourceLocationPath != undefined
					? extractSourceLocationSuffix(item.sourceLocationPath)
					: "";

			// ponytail: jha-advanced-table shows "--" when column id value is empty and skips renderers;
			// put non-empty display sentinels on the row so AC1/AC2 labels always show.
			const lastRunRaw = (item.lastRunDateTime ?? "").toString().trim();
			const rowForNext = {
				...item,
				transferType: item.transferType,
				status: item.status,
				sourceLocationPath_status: item.sourceLocationPath_status,
				scheduler: item.scheduler,
				nextScheduledRunTime: item.nextScheduledRunTime,
			};
			return {
				...item,
				actionId: item.workflowId,
				viewReport: item.workflowName || "Reporting",
				sourceType: "S3",
				sourceLocationPath_name,
				sourcePath,
				createDateTime: normalizeEpochSeconds(
					item.createDateTime != null && String(item.createDateTime).trim() !== ""
						? this.normalizeWorkflowDateRaw(String(item.createDateTime))
						: item.createDateTime,
				),
				updateDateTime: normalizeEpochSeconds(
					item.updateDateTime != null && String(item.updateDateTime).trim() !== ""
						? this.normalizeWorkflowDateRaw(String(item.updateDateTime))
						: item.updateDateTime,
				),
				lastRunDateTime: lastRunRaw || "Never",
				nextScheduledRunTime: this.formatNextScheduledRunDisplay(rowForNext),
			};
		});
		const sort = this.advancedTableConfig?.sort;
		return orderLoadedRowsByEpoch(rows, sort?.columnId, sort?.descending, [
			"createDateTime",
			"updateDateTime",
		]);
	}
	onWorkflowNameChange(e: { target: { value: string } }) {
		this.filterWorkflowName = e.target.value;
	}
	async onWorkflowNameClear() {
		this.filterWorkflowName = "";
	}

	onWorkflowNameFilterKeyDown(e: KeyboardEvent) {
		if (e.key === "Enter") {
			e.preventDefault();
			this.onSearchClick();
		}
	}

	onSearchClick() {
		this.isFilterSearch = true;
		this.bussinessUnit = this.filterBusinessUnit;
		this.getAllWorkflowList();
	}

	onFiltersClickReset() {
		this.filterWorkflowName = "";
		this.filterBusinessUnit = stringComparison(this.loggedUserType, "BusinessAdmin") ? this.filterBusinessUnit : "";
		this.filterTransferType = "";
		this.filterStatus = "";
		this.bussinessUnit = "";
		this.isFilterSearch = false;
		this.getAllWorkflowList();
	}

	/** workflow-search pagination is via query string (Count, PageKey, IsForward), not POST body. */
	buildWorkflowSearchUrl(pageKey: string, itemCount: number = this.pageLimit): string {
		const params = new URLSearchParams();
		params.set("count", String(itemCount));
		params.set("isForward", "True");
		if (pageKey) {
			params.set("pageKey", pageKey);
		}
		const q = params.toString();
		return q ? `${Apis.WORKFLOW_LIST}?${q}` : Apis.WORKFLOW_LIST;
	}

	private workflowListFilterBody() {
		const body: Record<string, any> = {
			workflowName: this.filterWorkflowName,
			businessUnit: this.bussinessUnit,
			transferType: this.filterTransferType,
			status: this.filterStatus,
		};
		if (this.advancedTableConfig.sort) {
			body.sortColumn = this.advancedTableConfig.sort.columnId;
			body.sortDescending = this.advancedTableConfig.sort.descending;
		}
		return body;
	}

	private transformWorkflowRowsInPlace(rows: any[]) {
		rows.forEach((element: any) => {
			element.transferType = element.transferType.charAt(0).toUpperCase() + element.transferType.slice(1).toLowerCase();
			element.sourceLocationPath_status = (element.workflowId ?? "") + "~" + element.status;
		});
	}

	private patchWorkflowRowStatus(workflowId: string, status: string, eTag?: string) {
		let patched = false;
		this.workflowData = this.workflowData.map((row) => {
			if (row.workflowId !== workflowId) {
				return row;
			}
			patched = true;
			return {
				...row,
				status,
				sourceLocationPath_status: workflowId + "~" + status,
				...(eTag ? { eTag } : {}),
			};
		});
		return patched;
	}

	/** Rows to ask for on the first workflow-search call after a full reload of the list (not for cursor "next" pages). */
	private firstPageFetchCount(): number {
		return Math.max(this.pageLimit, WorkflowMainView.WORKFLOW_FIRST_PAGE_MIN_COUNT);
	}

	/**
	 * Loads the workflow list. Returns false when the POST failed in jha-fetch (network/offline);
	 * callers should not run a second API (e.g. BU dropdown) in parallel or the user sees two identical jha-fetch toasts.
	 */
	async getAllWorkflowList(): Promise<boolean> {
		this.apiLoading = true;
		this.searchWorkflow = true;
		this.nextPageKey = "";
		const request = this.workflowListFilterBody();
		const searchUrl = this.buildWorkflowSearchUrl("", this.firstPageFetchCount());
		try {
			const response = await postRequest<{ workflowName: string }>(searchUrl, request);

			if (!response) {
				this.workflowData = [];
				this.nextPageKey = "";
				this.advancedTableConfig = {
					...this.advancedTableConfig,
					apiControlled: true,
					apiTotal: 0,
				};
				return false;
			}

			// postRequest returns raw Response for 401/404 — do not treat as JSON body
			if (typeof Response !== "undefined" && response instanceof Response) {
				this.workflowData = [];
				this.nextPageKey = "";
				this.advancedTableConfig = { ...this.advancedTableConfig, apiTotal: 0 };
				return true;
			}

			if (response?.messageStatus === null) {
				const _results = response?.results ?? [];
				this.workflowData = _results;
				this.transformWorkflowRowsInPlace(this.workflowData);

				this.workflowDataClone = this.workflowData;
				this.nextPageKey = response?.pageKey ?? "";
				this.advancedTableConfig = {
					...this.advancedTableConfig,
					apiControlled: true,
					apiTotal: response?.totalCount ?? 0,
				};
				return true;
			} else if (response?.status === StatusConstants.NOT_FOUND_USER_CODE) {
				this.workflowData = [];
				this.nextPageKey = "";
				this.advancedTableConfig = { ...this.advancedTableConfig, apiTotal: 0 };
				return true;
			} else if (response?.details?.length > 0) {
				const errMsg = getErrorMessage(response.details);
				showToast({
					message: errMsg,
					role: "danger",
					duration: GlobalVariables.TOAST_TIMEOUT,
				});
				return true;
			} else {
				showToast({
					message: "Something went wrong, please try again.",
					role: "danger",
					duration: GlobalVariables.TOAST_TIMEOUT,
				});
				return true;
			}
		} catch {
			return false;
		} finally {
			this.searchWorkflow = false;
			this.apiLoading = false;
		}
	}

	/** @returns false if the request failed or threw (caller must stop paging loops). */
	async fetchNextWorkflowPage(options?: { count?: number }) {
		if (!this.nextPageKey) {
			return false;
		}
		const request = this.workflowListFilterBody();
		const itemCount = options?.count ?? this.pageLimit;
		const searchUrl = this.buildWorkflowSearchUrl(this.nextPageKey, itemCount);
		try {
			const response = await postRequest<{ workflowName: string }>(searchUrl, request);

			if (!response) {
				this.nextPageKey = "";
				return false;
			}

			// Stop paging: raw Response (e.g. 401) leaves nextPageKey truthy unless cleared — would retry forever via scheduleWorkflowPageCatchUp
			if (typeof Response !== "undefined" && response instanceof Response) {
				this.nextPageKey = "";
				return false;
			}

			if (response?.messageStatus === null) {
				const nextRows = response?.results ?? [];
				this.transformWorkflowRowsInPlace(nextRows);
				this.workflowData = [...this.workflowData, ...nextRows];
				this.workflowDataClone = this.workflowData;
				this.nextPageKey = response?.pageKey ?? "";
				return true;
			}
			this.nextPageKey = "";
			if (response?.details?.length > 0) {
				const errMsg = getErrorMessage(response.details);
				showToast({
					message: errMsg,
					role: "danger",
					duration: GlobalVariables.TOAST_TIMEOUT,
				});
			} else {
				showToast({
					message: "Something went wrong, please try again.",
					role: "danger",
					duration: GlobalVariables.TOAST_TIMEOUT,
				});
			}
			return false;
		} catch {
			this.nextPageKey = "";
			return false;
		}
	}

	async handleLoadMore() {
		if (!this.advancedTableConfig.apiControlled || !this.nextPageKey) {
			return;
		}
		await this.enqueueWorkflowPagedOp(async () => {
			this.loadingMore = true;
			this.apiLoading = true;
			try {
				await this.fetchNextWorkflowPage();
			} finally {
				this.loadingMore = false;
				this.apiLoading = false;
			}
		});
	}

	async handleTableUpdate(event: any) {
		requestAnimationFrame(() => this.injectAdvancedTableStyles());
		const eventDetail = event.detail;
		if (eventDetail && eventDetail.type === "sort" && eventDetail.config) {
			const sortConfig = eventDetail.config.sort;
			if (sortConfig && sortConfig.columnId) {
				this.advancedTableConfig = {
					...this.advancedTableConfig,
					sort: {
						columnId: sortConfig.columnId,
						descending: sortConfig.descending === true,
					},
				};
				this.nextPageKey = "";
				this.requestUpdate();
				await this.getAllWorkflowList();
			}
		}
	}

	async getWorkflowStatus(e: { target: string }) {
		const workDataStatus = await getRequest(Apis.GET_WORKFLOW + `/` + fixedEncodeURIComponent(e.target));
		return workDataStatus.status;
	}

	onAddWorkflowClick() {
		AppRouters.go("/workflows/create-workflow");
	}

	onEditClick(workflowId: string) {
		AppRouters.go(`/workflows/edit-workflow/${workflowId}`);
	}

	onViewReportClick(workflowId: string, workflowName?: string) {
		const id = (workflowId ?? "").toString().trim();
		const wf = (workflowName ?? "").toString().trim();
		if (!id && !wf) {
			return;
		}
		const params: Record<string, string> = {};
		if (id) params.workflowId = id;
		if (wf) params.workflowName = wf;
		AppRouters.go("/audit-reporting", params);
	}

	onCloneClick(workflowId: string) {
		AppRouters.go(`/workflows/clone-workflow/${workflowId}`);
	}

	onRunWorkflowNowClick(row: {
		workflowId?: string;
		workflowName?: string;
		status?: string;
		sourceLocationPath_status?: string;
	}) {
		if (!this.canRunWorkflowNow(row)) {
			return;
		}
		const workflowId = row?.workflowId;
		if (!workflowId) {
			return;
		}

		const workflowLabel = (row.workflowName ?? "").trim() || "workflow";
		showToast({
			message: `Starting workflow run for "${workflowLabel}"…`,
			role: "success",
			duration: GlobalVariables.TOAST_TIMEOUT,
		});

		this.activatingWorkflowId = workflowId;
		void this.finishWorkflowActivation(workflowId, row.workflowName);
	}

	private async finishWorkflowActivation(workflowId: string, workflowName?: string) {
		try {
			const result = await activateWorkflow(workflowId, {
				maxWait: UI_ACTIVATION_MAX_WAIT_SECONDS,
			});
			const userMessage = buildWorkflowActivationUserMessage(result, workflowName);
			showToast({
				message: userMessage.message,
				role: userMessage.role,
				duration: GlobalVariables.TOAST_TIMEOUT,
			});
		} finally {
			if (this.activatingWorkflowId === workflowId) {
				this.activatingWorkflowId = null;
			}
		}
	}

	async onDeleteWorkflow(workflowId: string) {
		this.apiLoading = true;
		const workData = await getRequest(Apis.GET_WORKFLOW + `/` + fixedEncodeURIComponent(workflowId));
		if (!workData) {
			this.apiLoading = false;
			return;
		}
		const deleteWorkflow = await deleteRequest(Apis.DELETE_WORKFLOW + `/` + fixedEncodeURIComponent(workflowId), workData.eTag);
		if (!deleteWorkflow) {
			this.apiLoading = false;
			return;
		}
		if (deleteWorkflow?.status === 204) {
			this.apiLoading = false;
			showToast({
				message: "Workflow details deleted successfully.",
				role: "success",
				duration: GlobalVariables.TOAST_TIMEOUT,
			});
			const deleteIndex = this.workflowData.findIndex((x) => x.workflowId === workflowId);
			this.workflowData.splice(deleteIndex, 1);
		} else if (deleteWorkflow && deleteWorkflow.statusText !== null) {
			this.apiLoading = false;
			const errMsg = getErrorMessage(deleteWorkflow.statusText);
			showToast({
				message: errMsg,
				role: "danger",
				duration: GlobalVariables.TOAST_TIMEOUT,
			});
		} else {
			this.apiLoading = false;
			showToast({
				message: "Something went wrong, please try again.",
				role: "danger",
				duration: GlobalVariables.TOAST_TIMEOUT,
			});
		}
	}

	async onDeleteClick(workflowId: string) {
		const result = await openJhftDialog({
			variant: "danger",
			title: "Delete Workflow",
			message: "Are you sure you want to delete this workflow? This action cannot be undone.",
			cancelLabel: "Cancel",
			confirmLabel: "Delete",
		});
		if (result === "confirm") {
			await this.onDeleteWorkflow(workflowId);
		}
	}

	async updateWorkflowStatus(workflowId: string) {
		if (this.isReadOnlyUser || this.statusUpdateInFlightId === workflowId) {
			return;
		}

		this.statusUpdateInFlightId = workflowId;
		try {
			this.apiLoading = true;
			const workData = await getRequest(Apis.GET_WORKFLOW + `/` + fixedEncodeURIComponent(workflowId));
			if (!workData || workData.details?.length > 0) {
				await this.getAllWorkflowList();
				if (workData?.details?.length > 0) {
					showToast({
						message: getErrorMessage(workData.details),
						role: "danger",
						duration: GlobalVariables.TOAST_TIMEOUT,
					});
				}
				return;
			}

			const eTag = this.resolveWorkflowETag(workData);
			if (!eTag) {
				await this.getAllWorkflowList();
				showToast({
					message: "Unable to update workflow status. Please refresh and try again.",
					role: "danger",
					duration: GlobalVariables.TOAST_TIMEOUT,
				});
				return;
			}

			const updatedStatus = stringComparison(workData.status, "active") ? "inactive" : "active";
			const request = {
				status: updatedStatus,
				workflowId,
			};

			const updateWorkflow = await putRequest<{
				status: string;
				workflowId: string;
			}>(Apis.UPDATE_WORKFLOW_STATUS, eTag, request);

			if (!updateWorkflow) {
				await this.getAllWorkflowList();
				return;
			}

			if (updateWorkflow?.messageStatus === null) {
				this.patchWorkflowRowStatus(workflowId, updatedStatus, eTag);
				await this.getAllWorkflowList();
				showToast({
					message: "Workflow status updated successfully.",
					role: "success",
					duration: GlobalVariables.TOAST_TIMEOUT,
				});
			} else if (updateWorkflow?.details?.length > 0) {
				await this.getAllWorkflowList();
				const errMsg = getErrorMessage(updateWorkflow.details);
				showToast({
					message: errMsg,
					role: "danger",
					duration: GlobalVariables.TOAST_TIMEOUT,
				});
			} else {
				await this.getAllWorkflowList();
				showToast({
					message: "Something went wrong, please try again.",
					role: "danger",
					duration: GlobalVariables.TOAST_TIMEOUT,
				});
			}
		} finally {
			this.statusUpdateInFlightId = null;
			this.apiLoading = false;
		}
	}

	onBusinessUnitChange(e: { target: { value: string } }) {
		this.filterBusinessUnit = e.target.value;
	}
	onTransferTypeChange(e: { target: { value: string } }) {
		this.filterTransferType = e.target.value;
	}
	onStatusChange(e: { target: { value: string } }) {
		this.filterStatus = e.target.value;
	}
	onWorkflowFilterBusinessUnitSelectKeydown(e: KeyboardEvent) {
		filterSelectBackspaceClearKeydown(e, {
			value: this.filterBusinessUnit,
			locked: stringComparison(this.loggedUserType, "BusinessAdmin"),
			onClear: () => this.onBusinessUnitChange({ target: { value: "" } }),
		});
	}
	onWorkflowFilterTransferTypeSelectKeydown(e: KeyboardEvent) {
		filterSelectBackspaceClearKeydown(e, {
			value: this.filterTransferType,
			onClear: () => this.onTransferTypeChange({ target: { value: "" } }),
		});
	}
	onWorkflowFilterStatusSelectKeydown(e: KeyboardEvent) {
		filterSelectBackspaceClearKeydown(e, {
			value: this.filterStatus,
			onClear: () => this.onStatusChange({ target: { value: "" } }),
		});
	}
	updated(changed: PropertyValues) {
		super.updated?.(changed);
		const table = this.renderRoot.querySelector("jha-advanced-table") as HTMLElement | null;
		if (table) {
			table.toggleAttribute("data-api-loading", this.apiLoading || this.searchWorkflow || this.loadingMore);
			table.toggleAttribute("data-has-data", this.workflowData.length > 0);
		}
		requestAnimationFrame(() => this.injectAdvancedTableStyles());
	}

	private injectAdvancedTableStyles() {
		const table = this.renderRoot.querySelector("jha-advanced-table") as HTMLElement | null;
		const root = table?.shadowRoot;
		if (!root) return;
		const css = `
			${ADVANCED_TABLE_SORT_BUTTON_HEADER_STYLES_TEXT}
			${EFM_TIMEZONE_GRID_TABLE_SHADOW_STYLES_TEXT}
			${jhaDropdownMenuPanelStylesText}
			.loading jh-progress { visibility: hidden; }
			:host([data-api-loading]) .no-content,
			:host([data-has-data]) .no-content { visibility: hidden; }
			.no-content p {
				font-size: 20px;
				font-weight: 600;
				margin: 0;
			}
			${buildAdvancedTableEllipsisColumnShadowCss(["workflowName", "sourcePath"])}
			${buildAdvancedTableJhaTooltipOverflowEscapeCss(["createDateTime", "viewReport"])}
			jha-table-header#viewReport .col-header > span {
				text-align: center;
			}
			jha-table-cell#viewReport button[data-button] {
				display: flex;
				align-items: center;
				justify-content: center;
			}
			/* Single-path jha-icon-reports — solid accent (true multicolor not supported by this SVG) */
			jha-table-cell#viewReport jha-icon-reports {
				fill: var(--jha-color-primary, #1976d2);
				color: var(--jha-color-primary, #1976d2);
			}
			jha-table-cell#viewReport jha-button:hover jha-icon-reports {
				fill: var(--jha-color-primary-dark, #1565c0);
				color: var(--jha-color-primary-dark, #1565c0);
			}
			/* ACME-1349: Created Date tooltip — default max-width 160px clips; pre-line honors \\n */
			jha-table-cell#createDateTime jha-tooltip[bottom]::after {
				white-space: pre-line;
				max-width: 320px;
			}
			/* ACME-1349: Last Run icon color + vertical align with datetime */
			jha-table-cell#lastRunDateTime .last-run-cell {
				display: inline-flex;
				align-items: center;
				gap: 8px;
				white-space: nowrap;
				line-height: 1;
			}
			jha-table-cell#lastRunDateTime jha-icon-circle-checkmark-filled {
				fill: var(--jha-color-success, #2e7d32);
				color: var(--jha-color-success, #2e7d32);
				flex-shrink: 0;
			}
			jha-table-cell#lastRunDateTime jha-icon-circle-close-filled {
				fill: var(--jha-color-warning, #d32f2f);
				color: var(--jha-color-warning, #d32f2f);
				flex-shrink: 0;
			}
			jha-table-cell#lastRunDateTime,
			jha-table-cell#nextScheduledRunTime,
			jha-table-cell#createDateTime {
				vertical-align: middle;
			}
		`;
		let style = root.querySelector("style[data-acme-1180]") as HTMLStyleElement | null;
		if (!style) {
			style = document.createElement("style");
			style.setAttribute("data-acme-1180", "");
			root.appendChild(style);
		}
		style.textContent = css;
		applyAdvancedTableHeaderLayout(root);
		stripAdvancedTableRedundantTitles(
			root,
			WORKFLOW_GRID_ELLIPSIS_TITLE_COLUMN_IDS,
			WORKFLOW_PRESERVE_INNER_TITLE_COLUMN_IDS,
		);
	}

	renderTable() {
		return html`
			<jha-advanced-table
				style=${EFM_TIMEZONE_GRID_TABLE_STYLE}
				data-auto-id="workflowTable"
				.tableConfig=${this.advancedTableConfig}
				.columns=${this.columns}
				.data=${this.listData}
				.fullWidthColumns=${true}
				.pageLimit=${this.pageLimit}
				.allowPageChange=${true}
				.allowPageLimitChange=${true}
				.loading=${this.searchWorkflow}
				.loadingMore=${this.loadingMore}
				.noContentMessage=${"No Data to Display"}
			@pagination-forward=${this.handleLoadMore}
			@table-update=${this.handleTableUpdate}
		>
		</jha-advanced-table>
		`;
	}

	render() {
		return html`
			<slot>
				${this.apiLoading ? html`<circle-loader></circle-loader>` : undefined}
				<div id="workflowMain">
					<div id="formCon">
						<h1>Workflows</h1>
						<div class="inputContainer">
							<jha-tooltip bottom text="Click to add new workflow">
								<jha-button data-auto-id="addWorkflowBtn" type="button" primary large ?disabled=${this.isReadOnlyUser} sync @click=${this.onAddWorkflowClick}>
									<jha-icon-plus slot="icon-left"></jha-icon-plus>Add Workflow
								</jha-button>
							</jha-tooltip>
						</div>
					</div>
					<jha-table-row>
						<jha-collapsible-section is-open>
							<div slot="header">Advance Filters</div>
							<div slot="body" id="filterBody">
								<div id="filterId" style="display: flex; gap: 16px; flex-wrap: wrap;">
									<jh-tooltip bottom label="Search by Workflow Name">
										<jh-input
											show-clear-button
											label="Workflow Name"
											data-auto-id="searchIdInput"
											.placeholder=${"Search"}
											@jh-clear=${this.onWorkflowNameClear}
											.value=${this.filterWorkflowName}
											@input=${this.onWorkflowNameChange}
											@keydown=${this.onWorkflowNameFilterKeyDown}
											maxlength="256"
										>
										</jh-input>
									</jh-tooltip>
									<jha-tooltip bottom text="Select Business Unit. When focused, press Backspace to clear the selection.">
										<jha-form-select
											outline
											label="Business Unit"
											.options=${this.businessUnits}
											lableKey="name"
											valueKey="value"
											data-id="filterBusinessUnit"
											data-auto-id="businessUnitSelect"
											emptyOptionLabel="Select Business Unit"
											.value=${this.filterBusinessUnit}
											@change=${this.onBusinessUnitChange}
											@keydown=${this.onWorkflowFilterBusinessUnitSelectKeydown}
											?disabled=${stringComparison(this.loggedUserType, "BusinessAdmin")}
										></jha-form-select>
									</jha-tooltip>
									<jha-tooltip bottom text="Select Transfer Type. When focused, press Backspace to clear the selection.">
										<jha-form-select
											outline
											label="Transfer Type"
											.options=${this.transferType}
											lableKey="name"
											valueKey="value"
											.value=${this.filterTransferType}
											@change=${this.onTransferTypeChange}
											@keydown=${this.onWorkflowFilterTransferTypeSelectKeydown}
											data-id="filterTransferType"
											data-auto-id="transferTypeSelect"
											emptyOptionLabel="Select Transfer Type"
										></jha-form-select>
									</jha-tooltip>
									<jha-tooltip bottom text="Select Status. When focused, press Backspace to clear the selection.">
										<jha-form-select
											outline
											label="Status"
											.options=${this.statusType}
											lableKey="name"
											valueKey="value"
											.value=${this.filterStatus}
											@change=${this.onStatusChange}
											@keydown=${this.onWorkflowFilterStatusSelectKeydown}
											data-id="filterStatus"
											data-auto-id="statusSelect"
											emptyOptionLabel="Select Status"
										></jha-form-select>
									</jha-tooltip>
									<jha-tooltip text="Click Apply Filters to filter on selected criteria.">
										<jha-button style="margin:14%" data-auto-id="applyFiltersBtn" type="button" primary large sync @click=${this.onSearchClick}
											><jha-icon-filter slot="icon-left"></jha-icon-filter>Apply Filters</jha-button
										>
									</jha-tooltip>
									<jha-tooltip text="Click Reset Filters to clear all filters.">
										<jha-button style="margin:14%" data-auto-id="resetFiltersBtn" type="button" primary large sync @click=${this.onFiltersClickReset}
											><jha-icon-refresh slot="icon-left"></jha-icon-refresh>Reset Filters</jha-button
										>
									</jha-tooltip>
								</div>
							</div>
						</jha-collapsible-section>
					</jha-table-row>
					<jha-table-row>
						<div class="marginTop15px">
							<span
								><b>Note: </b> ${this.isFilterSearch
				? html`Records are displayed based on the Advance Filters you selected.`
				: html`All the displayed records are updated by you. To view additional records, please use the Advance Filters.`}</span
							>
						</div>
					</jha-table-row>
					<jha-card
						>${renderGridWithTimezoneBanner(this.renderTable())}</jha-card
					>
				</div>
			</slot>
		`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		"workflow-main-view": WorkflowMainView;
	}
}
